var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.svgClass},[_c('use',{style:(_vm.fill),attrs:{"href":`#icon-${_vm.iconName}`}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }